import { Component, Inject, Injector, ViewChild } from '@angular/core';
import { ScenarioResponseDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { CtTabDetailParameterNames } from '@cloud-twin-v2/navigation/ct-tab-details-parameter-names';
import { TabDetailPanelParameters } from '@common-modules/dependencies/navigation/tab-detail-panel-parameters';
import { WidgetSettingsToken } from '@common-modules/dynamic-layout/dynamic-layout-external-settings';
import { StateWidgetSettings } from '@common-modules/redux/models/state-widget-settings';
import { BaseWidgetComponent } from '@common-modules/shared/component/base-widget.component';
import { ModelVersionScenariosGridComponent } from '../model-version-scenarios-grid/model-version-scenarios-grid.component';

@Component({
  selector: 'ct-model-version-scenarios-grid-widget',
  templateUrl: './model-version-scenarios-grid-widget.component.html',
  styleUrl: './model-version-scenarios-grid-widget.component.scss',
  standalone: false
})
export class ModelVersionScenariosGridWidgetComponent extends BaseWidgetComponent {
  scenarios: ScenarioResponseDto[] = [];
  @ViewChild('scenariosGrid') scenariosGrid: ModelVersionScenariosGridComponent;

  constructor(
    injector: Injector,
    @Inject(WidgetSettingsToken) widgetSettings: StateWidgetSettings
  ) {
    super(injector, widgetSettings);
  }

  mapInitParameters(parameters: TabDetailPanelParameters) {
    this.scenarios = parameters.parameters.get(CtTabDetailParameterNames.scenariosGridRows);
  }

  reloadScenarios() {
    this.scenariosGrid?.reloadScenarios();
  }

  init(): void {}

  get componentName(): string {
    return 'ModelVersionScenariosGridWidgetComponent';
  }
}
